// redux/rootSaga.ts

import { all } from 'redux-saga/effects';

import watchAuditSaga from './audit/auditSaga';
import watchCardsSaga from './cards/cardsSaga';
import watchClientConfigurationSaga from './clientConfiguration/clientConfigurationSaga';
import { watchCommentsSaga } from './comments/commentsSaga';
import watchCustomersSaga from './customers/customersSaga';
import watchDestPointSaga from './destPoint/destPointSaga';
import watchDriversSaga from './drivers/driversSaga';
import { watchHistorySaga } from './history/historySaga';
import { watchIdentitySaga } from './identity/identitySaga';
import watchIotSaga from './iot/iotSaga';
import { watchUsersSaga } from './users/usersSaga';
import { watchAccessGroupsSaga } from './accessGroups/accessGroupsSaga';
import { watchIVAZSaga } from './ivaz/ivazSaga';
import watchLicensesSaga from './licenses/licensesSaga';
import watchOrdersSaga from './orders/ordersSaga';
import watchProductsSaga from './products/productsSaga';
import { watchReportsSaga } from './reports/reportsSaga';
import watchResultsaga from './results/resultsSaga';
import watchSettingsSaga from './settings/settingsSaga';
import watchSpySaga from './spy/spySaga';
import { watchToastSaga } from './toast/toastSaga';
import watchVehiclesSaga from './vehicles/vehiclesSaga';
import watchWeightingsSaga from './weightings/weightingsSaga';

export default function* rootSaga() {
 yield all([
  watchIdentitySaga(),
  watchUsersSaga(),
  watchAccessGroupsSaga(),
  watchResultsaga(),
  watchToastSaga(),
  watchClientConfigurationSaga(),
  watchReportsSaga(),
  watchCommentsSaga(),
  watchIVAZSaga(),
  watchHistorySaga(),
  watchCustomersSaga(),
  watchOrdersSaga(),
  watchDriversSaga(),
  watchVehiclesSaga(),
  watchWeightingsSaga(),
  watchProductsSaga(),
  watchSpySaga(),
  watchDestPointSaga(),
  watchCardsSaga(),
  watchSettingsSaga(),
  watchLicensesSaga(),
  watchAuditSaga(),
  watchIotSaga(),
 ]);
}

